import type { To } from "@mixitone/router";
import type RouteController from "controllers/RouteController";
import type { Location } from "react-router-dom";
import type { useModals, useNavigate } from "router";
import type { Path } from "../router";
import BaseService from "./BaseService";

type NavigateType = ReturnType<typeof useNavigate>;
type ModalsType = ReturnType<typeof useModals>;

export class RouteService extends BaseService {
  private controller!: RouteController;
  private static instance: RouteService | null = null;

  static getInstance(): RouteService {
    if (!RouteService.instance) {
      RouteService.instance = new RouteService();
    }
    return RouteService.instance;
  }

  setController(controller: RouteController) {
    this.controller = controller;
  }

  get location(): Location {
    return this.controller.state.location;
  }

  public openModal: ModalsType["open"] = (...args) => {
    this.controller.actionOpenModal(...args);
  };

  public closeModal: ModalsType["close"] = (...args) => {
    this.controller.actionCloseModal(...args);
  };

  public navigate<P extends Path | To<Path> | number>(...args: Parameters<NavigateType>) {
    this.controller.actionForward<P>(...args);
  }
}

export const routeService = RouteService.getInstance();
export default routeService;
